<template>
  <div>
    <!-- <div class="l-row">
      <div class="l-col-12@md">
        <a href="#!" @click="downloadExample">Arquivo exemplo</a>
      </div>
    </div> -->
    <div class="l-row">
      <form-group label="Arquivo (formato csv de no máx. 4MB)" :columns="6" required="true">
        <a href="#!" @click="downloadExample">Arquivo exemplo</a>
        <upload-file :validateFunction="validateFile" v-on:file="getFile" :data="uploadFileData"/>
      </form-group>
    </div>
  </div>
</template>

<script>
  import FormGroup from '@/components/template/FormGroup'
  import UploadFile from '@/components/template/UploadFile'
  import notifier from '@/notifier'

  export default {
    inject: ['priceTypeDI'],
    data: () => ({
      uploadFileData: {
        fileType: [
          'text/csv',
          'csv'
        ],
        fileSize: 4194304
      },
      options: {
        file: '',
        type: 'order'
      },
      fileExample: null
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      validateFile (headerFile) {
        const pattern = 'ORDER_NUMBER;INVOICE_NUMBER;INVOICE_SERIAL;INVOICE_KEY;INVOICE_DATE;TRACKING_CODE;TRACKING_URL;POST_DATE;DELIVERY_DATE'

        if (headerFile !== pattern) {
          notifier.error('Formato do arquivo inválido.', 'Erro')
          return false
        }

        return true
      },
      getFile (url) {
        this.options.file = url
      },
      downloadExample () {
        const csvContent = 'ORDER_NUMBER;INVOICE_NUMBER;INVOICE_SERIAL;INVOICE_KEY;INVOICE_DATE;TRACKING_CODE;TRACKING_URL;POST_DATE;DELIVERY_DATE\n999999999999;12345678901234;9;99940208589996000984550080008489081335194055;2024-02-21 09:13;9999;http://trackingUrl.com/9999;2024-02-21 09:13;2024-02-21 09:13'

        const link = document.createElement('a')
        link.style.display = 'none'

        const blob = new Blob([csvContent], { type: 'text/csv' })

        const url = URL.createObjectURL(blob)

        link.href = url
        link.download = 'ReprocessarPedidosExemplo.csv'

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)

        URL.revokeObjectURL(url)
      },
      getOptions () {
        return {
          file: this.options.file,
          type: this.options.type
        }
      }
    },
    components: {
      FormGroup,
      UploadFile
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin-top: 30px

</style>



// WEBPACK FOOTER //
// Options.vue?4a7841d9